import { both } from 'ramda';

import isNumber from '../../isNumber';

// eslint-disable-next-line no-restricted-globals
var isNaNPolyfill = /*#__PURE__*/both(isNumber, isNaN);

export default isNaNPolyfill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/internal/polyfills/Number.isNaN.js
// module id = 741
// module chunks = 0